module.exports = __webpack_public_path__ + "static/german-generals-talk-2e01fc17836f9b353e87c5bd4704de2e.jpg";